import { TextField } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React from "react";

import { TimePickerProps } from "./TimePicker.types";

const TimePicker = (props: TimePickerProps): JSX.Element => {
  const {
    label = "Choose time",
    time,
    onChange,
    disabled = false,
    style,
    variant = "outlined",
  } = props;

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <TextField
        label={label}
        id="time"
        type="time"
        variant={variant}
        value={time}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        InputLabelProps={{
          shrink: true,
        }}
        sx={{ ...style }}
      />
    </LocalizationProvider>
  );
};

export default TimePicker;
